module.exports = __webpack_public_path__ + "img/thomas-le-b@2x.f83c323c.png";